import "./style.css";
import MGInputWrapper from "../BuildingBlocks/MGInputWrapper";
import MGInput from "../BuildingBlocks/MGInput";
import PropTypes from "prop-types";

export const MGNumberBox = ({ value, placeholder, onChange, disabled, formikField, formikMeta }) => {
  const onChangeHandler = (evt) => {
    let newValue = evt === "" ? "" : evt.target.value;
    if (typeof onChange == "function") {
      onChange(newValue);
    }
  };

  return (
    <MGInputWrapper {...{ ...formikMeta }} disabled={disabled}>
      <MGInput
        {...formikField}
        type="number"
        value={value}
        onChange={onChangeHandler}
        placeholder={placeholder}
        disabled={disabled}
      ></MGInput>
    </MGInputWrapper>
  );
};

MGNumberBox.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  formikField: PropTypes.any,
  formikMeta: PropTypes.any,
};

MGNumberBox.defaultProps = {};

export default MGNumberBox;
